import { render } from "./work_on_project.vue?vue&type=template&id=74e29291&ts=true"
import script from "./work_on_project.vue?vue&type=script&lang=ts"
export * from "./work_on_project.vue?vue&type=script&lang=ts"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__